export default __webpack_public_path__ + "static/P_SearchThumb_IN-2905_Downloads-9f802fd42a81cb051bb16ba1746f203f.webp";